import React from 'react';

export const FormMetadataContext = React.createContext<Record<
  string,
  any
> | null>(null);

export const useFormMetadataContext = () => {
  const value = React.useContext(FormMetadataContext);
  return value;
};
